import _ from 'lodash'
// initial state
const state = {
  filter: {
    type: 'filter',
    search: '',
    bounds: [],
    zoom: 15.5
  },
  activeObjects: [],
  center: null,
  activeTool: 'pointer',
  mapMode: 'map',
  map: {
    style: 'mapbox://styles/mapbox/streets-v9',
    bounds: [],
    zoom: 15.5
  }
}

// getters
const getters = {
  getMapConfig (state) {
    return state.map
  },
  getFilterConfig (state) {
    return state.filter
  },
  getMapMode (state) {
    return state.mapMode
  },
  getActiveTool (state) {
    return state.activeTool
  },
  getActiveObjects (state) {
    return state.activeObjects
  },
  getCenter (state) {
    return state.center
  }
}

// actions
const actions = {
  setFilterConfig (store, data) {
    store.commit('setFilterConfig', data)
  },
  setMapConfig (store, data) {
    store.commit('setMapConfig', data)
  },
  setMapMode (store, data) {
    store.commit('setMapMode', data)
  },
  setActiveTool (store, data) {
    store.commit('setActiveTool', data)
  },
  addActiveObject (store, object) {
    if (_.findIndex(store.state.activeObjects, (data) => data.id == object.id) === -1) {
      store.commit('addActiveObject', object)
    }
  },
  removeActiveObject (store, object) {
    if (_.findIndex(store.state.activeObjects, (data) => data.id == object.id) > -1) {
      store.commit('removeActiveObject', object)
    }
  },
  setCenter (store, coordinates) {
    store.commit('setCenter', coordinates)
  }
}

// mutations
const mutations = {
  setFilterConfig (state, data) {
    state.filter = data
    localStorage.setItem('geoview.filter', JSON.stringify(state.filter))
  },
  setMapConfig (state, data) {
    state.map = data
    localStorage.setItem('geoview.map', JSON.stringify(state.map))
  },
  setMapMode (state, data) {
    state.mapMode = data
    localStorage.setItem('geoview.mapMode', JSON.stringify(state.mapMode))
  },
  setActiveTool (state, data) {
    state.activeTool = data
    localStorage.setItem('geoview.activeTool', JSON.stringify(state.activeTool))
  },
  addActiveObject (state, object) {
    state.activeObjects.push(object)
  },
  removeActiveObject (state, object) {
    state.activeObjects.splice(_.findIndex(state.activeObjects, item => item.id === object.id), 1)
  },
  setCenter (state, coordinates) {
    state.center = coordinates
  },
  initialise (state) {
    if (localStorage.getItem('geoview.filter')) {
      state.filter = JSON.parse(localStorage.getItem('geoview.filter'))
    }

    if (localStorage.getItem('geoview.map')) {
      state.map = JSON.parse(localStorage.getItem('geoview.map'))
    }

    if (localStorage.getItem('geoview.mapMode')) {
      state.mapMode = JSON.parse(localStorage.getItem('geoview.mapMode'))
    }

    if (localStorage.getItem('geoview.activeTool')) {
      state.activeTool = JSON.parse(localStorage.getItem('geoview.activeTool'))
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
